module.exports = __webpack_public_path__ + "img/pictlogo.6f567d04.png";